export class Scene {
    constructor() {
        this.objects = [];
    }
    add(geometry) {
        this.objects.push(geometry);
    }
    clear() {
        this.objects = [];
    }
}
